import { Text } from "@dropbox/dig-components/typography";
import { getTimeAgoStringFromTimestamp } from "@mirage/search/SearchResults/util/resultUtil";
import { last, upperCase } from "lodash";

import type { SearchResult } from "@mirage/shared/search/search-result";

export const MultimediaResultMetaInfo = ({
  result,
}: {
  result: SearchResult;
}) => {
  const components = [];
  const prefix = result.title.includes(".")
    ? upperCase(last(result.title.split(".")))
    : "";
  if (prefix) {
    components.push(prefix);
  }
  const timeAgoString = getTimeAgoStringFromTimestamp(
    result.providerUpdateAtMs,
    true,
  );
  if (timeAgoString) {
    components.push(timeAgoString);
  }
  const text = components.join(" • ");
  return (
    <Text color="subtle" size="small">
      {text}
    </Text>
  );
};
